var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "60%",
      "persistent": ""
    },
    on: {
      "input": _vm.closeModal
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Добавить') + " ")]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0 pt-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '########',
      expression: "'########'"
    }],
    attrs: {
      "label": "Номер протокола",
      "placeholder": "Введите номер протокола",
      "outlined": "",
      "dense": "",
      "rounded": "",
      "error-messages": _vm.errorMessages.protocolNumber
    },
    on: {
      "input": function input($event) {
        return _vm.$v.protocol.protocolNumber.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.protocol.protocolNumber.$touch();
      }
    },
    model: {
      value: _vm.protocol.protocolNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.protocol, "protocolNumber", $$v);
      },
      expression: "protocol.protocolNumber"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('UIDatePicker', {
    attrs: {
      "label": "Дата протокола",
      "error-messages": _vm.errorMessages.protocolDate
    },
    on: {
      "input": function input($event) {
        return _vm.$v.protocol.protocolDate.$touch();
      }
    },
    model: {
      value: _vm.protocol.protocolDate,
      callback: function callback($$v) {
        _vm.$set(_vm.protocol, "protocolDate", $$v);
      },
      expression: "protocol.protocolDate"
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s('Отмена') + " ")]), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.$v.$invalid,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveProtocol
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Сохранить' : 'Создать') + " ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }